export default {
	app_install_banner_question: 'Möchten Sie die infra-struktur App installieren?',
	app_install_banner_question_choice_later: 'später aktualisieren',
	app_install_banner_question_choice_never: 'Niemals',
	app_install_banner_question_choice_yes: 'jetzt aktualisieren',
	app_loading_indicator_downloading: 'Lade herunter...',
	app_loading_indicator_refreshing: 'Aktualisiere...',
	app_loading_indicator_searching: 'Suche...',
	app_loading_indicator_state_changing: 'Statuswechsel wird durchgeführt...',
	app_login_failed: 'Die von Ihnen angegebene Kombination aus Benutzername und Passwort ist falsch.',
	app_login_failed_ok_button_label: 'OK',
	app_login_failed_with_token:
		'Die von Ihnen angegebene Kombination aus Benutzername und Passwort und 2FA Code ist falsch.',
	app_not_unlocked:
		'Ihr Benutzer ist nicht für die Verwendung der infra-struktur App freigeschaltet. Bitte wenden Sie sich an den infra-struktur Support.',
	app_not_unlocked_ok_button_label: 'OK',
	app_offline_banner:
		'Sie haben die Verbindung zum Internet verloren, die App ist offline und kann nicht genutzt werden.',
	app_update_banner_question: 'Möchten Sie die infra-struktur App aktualisieren?',
	app_update_banner_question_choice_later: 'In 4 Stunden erneut fragen',
	app_update_banner_question_choice_yes: 'Jetzt aktualisieren',
	app_version_mismatch_message:
		'Ihre App-Version ist nicht mit der infra-struktur-Version kompatibel. Bitte aktualisieren Sie die App.',
	app_version_mismatch_update_button: 'Jetzt aktualisieren',
};
